export type BrowserEscapeOwner = 'focused-control' | 'layer' | 'pane' | 'modal';

export interface BrowserEscapeState {
    // The focused element already used the key, e.g. a search box clearing its text.
    usedByFocus: boolean;
    // A popover, gallery or 3D overlay is open in the browser, or focus sits in another dialog.
    layerOpen: boolean;
    // The visible tab's details pane is open; a hidden tab's pane never counts.
    paneOpen: boolean;
}

// One layer per Escape, top down; where focus sits in the browser doesn't change the order.
export function browserEscapeOwner(state: BrowserEscapeState): BrowserEscapeOwner {
    if (state.usedByFocus) return 'focused-control';
    if (state.layerOpen) return 'layer';
    return state.paneOpen ? 'pane' : 'modal';
}
